import userReducer from "@/components/navigation/ducks/slice"
import { combineReducers } from "@reduxjs/toolkit"

const navigationReducer = combineReducers({
  user: userReducer,
})

export default navigationReducer
